export const timezoneChoices = [
  {
    id: "Africa/Abidjan",
    timezone: "Africa/Abidjan"
  },
  {
    id: "Africa/Algiers",
    timezone: "Africa/Algiers"
  },
  {
    id: "Africa/Bissau",
    timezone: "Africa/Bissau"
  },
  {
    id: "Africa/Cairo",
    timezone: "Africa/Cairo"
  },
  {
    id: "Africa/Casablanca",
    timezone: "Africa/Casablanca"
  },
  {
    id: "Africa/Ceuta",
    timezone: "Africa/Ceuta"
  },
  {
    id: "Africa/El_Aaiun",
    timezone: "Africa/El_Aaiun"
  },
  {
    id: "Africa/Johannesburg",
    timezone: "Africa/Johannesburg"
  },
  {
    id: "Africa/Juba",
    timezone: "Africa/Juba"
  },
  {
    id: "Africa/Khartoum",
    timezone: "Africa/Khartoum"
  },
  {
    id: "Africa/Lagos",
    timezone: "Africa/Lagos"
  },
  {
    id: "Africa/Maputo",
    timezone: "Africa/Maputo"
  },
  {
    id: "Africa/Monrovia",
    timezone: "Africa/Monrovia"
  },
  {
    id: "Africa/Nairobi",
    timezone: "Africa/Nairobi"
  },
  {
    id: "Africa/Ndjamena",
    timezone: "Africa/Ndjamena"
  },
  {
    id: "Africa/Sao_Tome",
    timezone: "Africa/Sao_Tome"
  },
  {
    id: "Africa/Tripoli",
    timezone: "Africa/Tripoli"
  },
  {
    id: "Africa/Tunis",
    timezone: "Africa/Tunis"
  },
  {
    id: "Africa/Windhoek",
    timezone: "Africa/Windhoek"
  },
  {
    id: "America/Adak",
    timezone: "America/Adak"
  },
  {
    id: "America/Anchorage",
    timezone: "America/Anchorage"
  },
  {
    id: "America/Araguaina",
    timezone: "America/Araguaina"
  },
  {
    id: "America/Argentina/Buenos_Aires",
    timezone: "America/Argentina/Buenos_Aires"
  },
  {
    id: "America/Argentina/Catamarca",
    timezone: "America/Argentina/Catamarca"
  },
  {
    id: "America/Argentina/Cordoba",
    timezone: "America/Argentina/Cordoba"
  },
  {
    id: "America/Argentina/Jujuy",
    timezone: "America/Argentina/Jujuy"
  },
  {
    id: "America/Argentina/La_Rioja",
    timezone: "America/Argentina/La_Rioja"
  },
  {
    id: "America/Argentina/Mendoza",
    timezone: "America/Argentina/Mendoza"
  },
  {
    id: "America/Argentina/Rio_Gallegos",
    timezone: "America/Argentina/Rio_Gallegos"
  },
  {
    id: "America/Argentina/Salta",
    timezone: "America/Argentina/Salta"
  },
  {
    id: "America/Argentina/San_Juan",
    timezone: "America/Argentina/San_Juan"
  },
  {
    id: "America/Argentina/San_Luis",
    timezone: "America/Argentina/San_Luis"
  },
  {
    id: "America/Argentina/Tucuman",
    timezone: "America/Argentina/Tucuman"
  },
  {
    id: "America/Argentina/Ushuaia",
    timezone: "America/Argentina/Ushuaia"
  },
  {
    id: "America/Asuncion",
    timezone: "America/Asuncion"
  },
  {
    id: "America/Bahia",
    timezone: "America/Bahia"
  },
  {
    id: "America/Bahia_Banderas",
    timezone: "America/Bahia_Banderas"
  },
  {
    id: "America/Barbados",
    timezone: "America/Barbados"
  },
  {
    id: "America/Belem",
    timezone: "America/Belem"
  },
  {
    id: "America/Belize",
    timezone: "America/Belize"
  },
  {
    id: "America/Boa_Vista",
    timezone: "America/Boa_Vista"
  },
  {
    id: "America/Bogota",
    timezone: "America/Bogota"
  },
  {
    id: "America/Boise",
    timezone: "America/Boise"
  },
  {
    id: "America/Cambridge_Bay",
    timezone: "America/Cambridge_Bay"
  },
  {
    id: "America/Campo_Grande",
    timezone: "America/Campo_Grande"
  },
  {
    id: "America/Cancun",
    timezone: "America/Cancun"
  },
  {
    id: "America/Caracas",
    timezone: "America/Caracas"
  },
  {
    id: "America/Cayenne",
    timezone: "America/Cayenne"
  },
  {
    id: "America/Chicago",
    timezone: "America/Chicago"
  },
  {
    id: "America/Chihuahua",
    timezone: "America/Chihuahua"
  },
  {
    id: "America/Ciudad_Juarez",
    timezone: "America/Ciudad_Juarez"
  },
  {
    id: "America/Costa_Rica",
    timezone: "America/Costa_Rica"
  },
  {
    id: "America/Cuiaba",
    timezone: "America/Cuiaba"
  },
  {
    id: "America/Danmarkshavn",
    timezone: "America/Danmarkshavn"
  },
  {
    id: "America/Dawson",
    timezone: "America/Dawson"
  },
  {
    id: "America/Dawson_Creek",
    timezone: "America/Dawson_Creek"
  },
  {
    id: "America/Denver",
    timezone: "America/Denver"
  },
  {
    id: "America/Detroit",
    timezone: "America/Detroit"
  },
  {
    id: "America/Edmonton",
    timezone: "America/Edmonton"
  },
  {
    id: "America/Eirunepe",
    timezone: "America/Eirunepe"
  },
  {
    id: "America/El_Salvador",
    timezone: "America/El_Salvador"
  },
  {
    id: "America/Fort_Nelson",
    timezone: "America/Fort_Nelson"
  },
  {
    id: "America/Fortaleza",
    timezone: "America/Fortaleza"
  },
  {
    id: "America/Glace_Bay",
    timezone: "America/Glace_Bay"
  },
  {
    id: "America/Goose_Bay",
    timezone: "America/Goose_Bay"
  },
  {
    id: "America/Grand_Turk",
    timezone: "America/Grand_Turk"
  },
  {
    id: "America/Guatemala",
    timezone: "America/Guatemala"
  },
  {
    id: "America/Guayaquil",
    timezone: "America/Guayaquil"
  },
  {
    id: "America/Guyana",
    timezone: "America/Guyana"
  },
  {
    id: "America/Halifax",
    timezone: "America/Halifax"
  },
  {
    id: "America/Havana",
    timezone: "America/Havana"
  },
  {
    id: "America/Hermosillo",
    timezone: "America/Hermosillo"
  },
  {
    id: "America/Indiana/Indianapolis",
    timezone: "America/Indiana/Indianapolis"
  },
  {
    id: "America/Indiana/Knox",
    timezone: "America/Indiana/Knox"
  },
  {
    id: "America/Indiana/Marengo",
    timezone: "America/Indiana/Marengo"
  },
  {
    id: "America/Indiana/Petersburg",
    timezone: "America/Indiana/Petersburg"
  },
  {
    id: "America/Indiana/Tell_City",
    timezone: "America/Indiana/Tell_City"
  },
  {
    id: "America/Indiana/Vevay",
    timezone: "America/Indiana/Vevay"
  },
  {
    id: "America/Indiana/Vincennes",
    timezone: "America/Indiana/Vincennes"
  },
  {
    id: "America/Indiana/Winamac",
    timezone: "America/Indiana/Winamac"
  },
  {
    id: "America/Inuvik",
    timezone: "America/Inuvik"
  },
  {
    id: "America/Iqaluit",
    timezone: "America/Iqaluit"
  },
  {
    id: "America/Jamaica",
    timezone: "America/Jamaica"
  },
  {
    id: "America/Juneau",
    timezone: "America/Juneau"
  },
  {
    id: "America/Kentucky/Louisville",
    timezone: "America/Kentucky/Louisville"
  },
  {
    id: "America/Kentucky/Monticello",
    timezone: "America/Kentucky/Monticello"
  },
  {
    id: "America/La_Paz",
    timezone: "America/La_Paz"
  },
  {
    id: "America/Lima",
    timezone: "America/Lima"
  },
  {
    id: "America/Los_Angeles",
    timezone: "America/Los_Angeles"
  },
  {
    id: "America/Maceio",
    timezone: "America/Maceio"
  },
  {
    id: "America/Managua",
    timezone: "America/Managua"
  },
  {
    id: "America/Manaus",
    timezone: "America/Manaus"
  },
  {
    id: "America/Martinique",
    timezone: "America/Martinique"
  },
  {
    id: "America/Matamoros",
    timezone: "America/Matamoros"
  },
  {
    id: "America/Mazatlan",
    timezone: "America/Mazatlan"
  },
  {
    id: "America/Menominee",
    timezone: "America/Menominee"
  },
  {
    id: "America/Merida",
    timezone: "America/Merida"
  },
  {
    id: "America/Metlakatla",
    timezone: "America/Metlakatla"
  },
  {
    id: "America/Mexico_City",
    timezone: "America/Mexico_City"
  },
  {
    id: "America/Miquelon",
    timezone: "America/Miquelon"
  },
  {
    id: "America/Moncton",
    timezone: "America/Moncton"
  },
  {
    id: "America/Monterrey",
    timezone: "America/Monterrey"
  },
  {
    id: "America/Montevideo",
    timezone: "America/Montevideo"
  },
  {
    id: "America/New_York",
    timezone: "America/New_York"
  },
  {
    id: "America/Nome",
    timezone: "America/Nome"
  },
  {
    id: "America/Noronha",
    timezone: "America/Noronha"
  },
  {
    id: "America/North_Dakota/Beulah",
    timezone: "America/North_Dakota/Beulah"
  },
  {
    id: "America/North_Dakota/Center",
    timezone: "America/North_Dakota/Center"
  },
  {
    id: "America/North_Dakota/New_Salem",
    timezone: "America/North_Dakota/New_Salem"
  },
  {
    id: "America/Nuuk",
    timezone: "America/Nuuk"
  },
  {
    id: "America/Ojinaga",
    timezone: "America/Ojinaga"
  },
  {
    id: "America/Panama",
    timezone: "America/Panama"
  },
  {
    id: "America/Paramaribo",
    timezone: "America/Paramaribo"
  },
  {
    id: "America/Phoenix",
    timezone: "America/Phoenix"
  },
  {
    id: "America/Port-au-Prince",
    timezone: "America/Port-au-Prince"
  },
  {
    id: "America/Porto_Velho",
    timezone: "America/Porto_Velho"
  },
  {
    id: "America/Puerto_Rico",
    timezone: "America/Puerto_Rico"
  },
  {
    id: "America/Punta_Arenas",
    timezone: "America/Punta_Arenas"
  },
  {
    id: "America/Rankin_Inlet",
    timezone: "America/Rankin_Inlet"
  },
  {
    id: "America/Recife",
    timezone: "America/Recife"
  },
  {
    id: "America/Regina",
    timezone: "America/Regina"
  },
  {
    id: "America/Resolute",
    timezone: "America/Resolute"
  },
  {
    id: "America/Rio_Branco",
    timezone: "America/Rio_Branco"
  },
  {
    id: "America/Santarem",
    timezone: "America/Santarem"
  },
  {
    id: "America/Santiago",
    timezone: "America/Santiago"
  },
  {
    id: "America/Santo_Domingo",
    timezone: "America/Santo_Domingo"
  },
  {
    id: "America/Sao_Paulo",
    timezone: "America/Sao_Paulo"
  },
  {
    id: "America/Scoresbysund",
    timezone: "America/Scoresbysund"
  },
  {
    id: "America/Sitka",
    timezone: "America/Sitka"
  },
  {
    id: "America/St_Johns",
    timezone: "America/St_Johns"
  },
  {
    id: "America/Swift_Current",
    timezone: "America/Swift_Current"
  },
  {
    id: "America/Tegucigalpa",
    timezone: "America/Tegucigalpa"
  },
  {
    id: "America/Thule",
    timezone: "America/Thule"
  },
  {
    id: "America/Tijuana",
    timezone: "America/Tijuana"
  },
  {
    id: "America/Toronto",
    timezone: "America/Toronto"
  },
  {
    id: "America/Vancouver",
    timezone: "America/Vancouver"
  },
  {
    id: "America/Whitehorse",
    timezone: "America/Whitehorse"
  },
  {
    id: "America/Winnipeg",
    timezone: "America/Winnipeg"
  },
  {
    id: "America/Yakutat",
    timezone: "America/Yakutat"
  },
  {
    id: "Antarctica/Casey",
    timezone: "Antarctica/Casey"
  },
  {
    id: "Antarctica/Davis",
    timezone: "Antarctica/Davis"
  },
  {
    id: "Antarctica/Macquarie",
    timezone: "Antarctica/Macquarie"
  },
  {
    id: "Antarctica/Mawson",
    timezone: "Antarctica/Mawson"
  },
  {
    id: "Antarctica/Palmer",
    timezone: "Antarctica/Palmer"
  },
  {
    id: "Antarctica/Rothera",
    timezone: "Antarctica/Rothera"
  },
  {
    id: "Antarctica/Troll",
    timezone: "Antarctica/Troll"
  },
  {
    id: "Asia/Almaty",
    timezone: "Asia/Almaty"
  },
  {
    id: "Asia/Amman",
    timezone: "Asia/Amman"
  },
  {
    id: "Asia/Anadyr",
    timezone: "Asia/Anadyr"
  },
  {
    id: "Asia/Aqtau",
    timezone: "Asia/Aqtau"
  },
  {
    id: "Asia/Aqtobe",
    timezone: "Asia/Aqtobe"
  },
  {
    id: "Asia/Ashgabat",
    timezone: "Asia/Ashgabat"
  },
  {
    id: "Asia/Atyrau",
    timezone: "Asia/Atyrau"
  },
  {
    id: "Asia/Baghdad",
    timezone: "Asia/Baghdad"
  },
  {
    id: "Asia/Baku",
    timezone: "Asia/Baku"
  },
  {
    id: "Asia/Bangkok",
    timezone: "Asia/Bangkok"
  },
  {
    id: "Asia/Barnaul",
    timezone: "Asia/Barnaul"
  },
  {
    id: "Asia/Beirut",
    timezone: "Asia/Beirut"
  },
  {
    id: "Asia/Bishkek",
    timezone: "Asia/Bishkek"
  },
  {
    id: "Asia/Chita",
    timezone: "Asia/Chita"
  },
  {
    id: "Asia/Choibalsan",
    timezone: "Asia/Choibalsan"
  },
  {
    id: "Asia/Colombo",
    timezone: "Asia/Colombo"
  },
  {
    id: "Asia/Damascus",
    timezone: "Asia/Damascus"
  },
  {
    id: "Asia/Dhaka",
    timezone: "Asia/Dhaka"
  },
  {
    id: "Asia/Dili",
    timezone: "Asia/Dili"
  },
  {
    id: "Asia/Dubai",
    timezone: "Asia/Dubai"
  },
  {
    id: "Asia/Dushanbe",
    timezone: "Asia/Dushanbe"
  },
  {
    id: "Asia/Famagusta",
    timezone: "Asia/Famagusta"
  },
  {
    id: "Asia/Gaza",
    timezone: "Asia/Gaza"
  },
  {
    id: "Asia/Hebron",
    timezone: "Asia/Hebron"
  },
  {
    id: "Asia/Ho_Chi_Minh",
    timezone: "Asia/Ho_Chi_Minh"
  },
  {
    id: "Asia/Hong_Kong",
    timezone: "Asia/Hong_Kong"
  },
  {
    id: "Asia/Hovd",
    timezone: "Asia/Hovd"
  },
  {
    id: "Asia/Irkutsk",
    timezone: "Asia/Irkutsk"
  },
  {
    id: "Asia/Jakarta",
    timezone: "Asia/Jakarta"
  },
  {
    id: "Asia/Jayapura",
    timezone: "Asia/Jayapura"
  },
  {
    id: "Asia/Jerusalem",
    timezone: "Asia/Jerusalem"
  },
  {
    id: "Asia/Kabul",
    timezone: "Asia/Kabul"
  },
  {
    id: "Asia/Kamchatka",
    timezone: "Asia/Kamchatka"
  },
  {
    id: "Asia/Karachi",
    timezone: "Asia/Karachi"
  },
  {
    id: "Asia/Kathmandu",
    timezone: "Asia/Kathmandu"
  },
  {
    id: "Asia/Khandyga",
    timezone: "Asia/Khandyga"
  },
  {
    id: "Asia/Kolkata",
    timezone: "Asia/Kolkata"
  },
  {
    id: "Asia/Krasnoyarsk",
    timezone: "Asia/Krasnoyarsk"
  },
  {
    id: "Asia/Kuching",
    timezone: "Asia/Kuching"
  },
  {
    id: "Asia/Macau",
    timezone: "Asia/Macau"
  },
  {
    id: "Asia/Magadan",
    timezone: "Asia/Magadan"
  },
  {
    id: "Asia/Makassar",
    timezone: "Asia/Makassar"
  },
  {
    id: "Asia/Manila",
    timezone: "Asia/Manila"
  },
  {
    id: "Asia/Nicosia",
    timezone: "Asia/Nicosia"
  },
  {
    id: "Asia/Novokuznetsk",
    timezone: "Asia/Novokuznetsk"
  },
  {
    id: "Asia/Novosibirsk",
    timezone: "Asia/Novosibirsk"
  },
  {
    id: "Asia/Omsk",
    timezone: "Asia/Omsk"
  },
  {
    id: "Asia/Oral",
    timezone: "Asia/Oral"
  },
  {
    id: "Asia/Pontianak",
    timezone: "Asia/Pontianak"
  },
  {
    id: "Asia/Pyongyang",
    timezone: "Asia/Pyongyang"
  },
  {
    id: "Asia/Qatar",
    timezone: "Asia/Qatar"
  },
  {
    id: "Asia/Qostanay",
    timezone: "Asia/Qostanay"
  },
  {
    id: "Asia/Qyzylorda",
    timezone: "Asia/Qyzylorda"
  },
  {
    id: "Asia/Riyadh",
    timezone: "Asia/Riyadh"
  },
  {
    id: "Asia/Sakhalin",
    timezone: "Asia/Sakhalin"
  },
  {
    id: "Asia/Samarkand",
    timezone: "Asia/Samarkand"
  },
  {
    id: "Asia/Seoul",
    timezone: "Asia/Seoul"
  },
  {
    id: "Asia/Shanghai",
    timezone: "Asia/Shanghai"
  },
  {
    id: "Asia/Singapore",
    timezone: "Asia/Singapore"
  },
  {
    id: "Asia/Srednekolymsk",
    timezone: "Asia/Srednekolymsk"
  },
  {
    id: "Asia/Taipei",
    timezone: "Asia/Taipei"
  },
  {
    id: "Asia/Tashkent",
    timezone: "Asia/Tashkent"
  },
  {
    id: "Asia/Tbilisi",
    timezone: "Asia/Tbilisi"
  },
  {
    id: "Asia/Tehran",
    timezone: "Asia/Tehran"
  },
  {
    id: "Asia/Thimphu",
    timezone: "Asia/Thimphu"
  },
  {
    id: "Asia/Tokyo",
    timezone: "Asia/Tokyo"
  },
  {
    id: "Asia/Tomsk",
    timezone: "Asia/Tomsk"
  },
  {
    id: "Asia/Ulaanbaatar",
    timezone: "Asia/Ulaanbaatar"
  },
  {
    id: "Asia/Urumqi",
    timezone: "Asia/Urumqi"
  },
  {
    id: "Asia/Ust-Nera",
    timezone: "Asia/Ust-Nera"
  },
  {
    id: "Asia/Vladivostok",
    timezone: "Asia/Vladivostok"
  },
  {
    id: "Asia/Yakutsk",
    timezone: "Asia/Yakutsk"
  },
  {
    id: "Asia/Yangon",
    timezone: "Asia/Yangon"
  },
  {
    id: "Asia/Yekaterinburg",
    timezone: "Asia/Yekaterinburg"
  },
  {
    id: "Asia/Yerevan",
    timezone: "Asia/Yerevan"
  },
  {
    id: "Atlantic/Azores",
    timezone: "Atlantic/Azores"
  },
  {
    id: "Atlantic/Bermuda",
    timezone: "Atlantic/Bermuda"
  },
  {
    id: "Atlantic/Canary",
    timezone: "Atlantic/Canary"
  },
  {
    id: "Atlantic/Cape_Verde",
    timezone: "Atlantic/Cape_Verde"
  },
  {
    id: "Atlantic/Faroe",
    timezone: "Atlantic/Faroe"
  },
  {
    id: "Atlantic/Madeira",
    timezone: "Atlantic/Madeira"
  },
  {
    id: "Atlantic/South_Georgia",
    timezone: "Atlantic/South_Georgia"
  },
  {
    id: "Atlantic/Stanley",
    timezone: "Atlantic/Stanley"
  },
  {
    id: "Australia/Adelaide",
    timezone: "Australia/Adelaide"
  },
  {
    id: "Australia/Brisbane",
    timezone: "Australia/Brisbane"
  },
  {
    id: "Australia/Broken_Hill",
    timezone: "Australia/Broken_Hill"
  },
  {
    id: "Australia/Darwin",
    timezone: "Australia/Darwin"
  },
  {
    id: "Australia/Eucla",
    timezone: "Australia/Eucla"
  },
  {
    id: "Australia/Hobart",
    timezone: "Australia/Hobart"
  },
  {
    id: "Australia/Lindeman",
    timezone: "Australia/Lindeman"
  },
  {
    id: "Australia/Lord_Howe",
    timezone: "Australia/Lord_Howe"
  },
  {
    id: "Australia/Melbourne",
    timezone: "Australia/Melbourne"
  },
  {
    id: "Australia/Perth",
    timezone: "Australia/Perth"
  },
  {
    id: "Australia/Sydney",
    timezone: "Australia/Sydney"
  },
  {
    id: "CET",
    timezone: "CET"
  },
  {
    id: "CST6CDT",
    timezone: "CST6CDT"
  },
  {
    id: "EET",
    timezone: "EET"
  },
  {
    id: "EST",
    timezone: "EST"
  },
  {
    id: "EST5EDT",
    timezone: "EST5EDT"
  },
  {
    id: "Etc/GMT",
    timezone: "Etc/GMT"
  },
  {
    id: "Etc/GMT+1",
    timezone: "Etc/GMT+1"
  },
  {
    id: "Etc/GMT+10",
    timezone: "Etc/GMT+10"
  },
  {
    id: "Etc/GMT+11",
    timezone: "Etc/GMT+11"
  },
  {
    id: "Etc/GMT+12",
    timezone: "Etc/GMT+12"
  },
  {
    id: "Etc/GMT+2",
    timezone: "Etc/GMT+2"
  },
  {
    id: "Etc/GMT+3",
    timezone: "Etc/GMT+3"
  },
  {
    id: "Etc/GMT+4",
    timezone: "Etc/GMT+4"
  },
  {
    id: "Etc/GMT+5",
    timezone: "Etc/GMT+5"
  },
  {
    id: "Etc/GMT+6",
    timezone: "Etc/GMT+6"
  },
  {
    id: "Etc/GMT+7",
    timezone: "Etc/GMT+7"
  },
  {
    id: "Etc/GMT+8",
    timezone: "Etc/GMT+8"
  },
  {
    id: "Etc/GMT+9",
    timezone: "Etc/GMT+9"
  },
  {
    id: "Etc/GMT-1",
    timezone: "Etc/GMT-1"
  },
  {
    id: "Etc/GMT-10",
    timezone: "Etc/GMT-10"
  },
  {
    id: "Etc/GMT-11",
    timezone: "Etc/GMT-11"
  },
  {
    id: "Etc/GMT-12",
    timezone: "Etc/GMT-12"
  },
  {
    id: "Etc/GMT-13",
    timezone: "Etc/GMT-13"
  },
  {
    id: "Etc/GMT-14",
    timezone: "Etc/GMT-14"
  },
  {
    id: "Etc/GMT-2",
    timezone: "Etc/GMT-2"
  },
  {
    id: "Etc/GMT-3",
    timezone: "Etc/GMT-3"
  },
  {
    id: "Etc/GMT-4",
    timezone: "Etc/GMT-4"
  },
  {
    id: "Etc/GMT-5",
    timezone: "Etc/GMT-5"
  },
  {
    id: "Etc/GMT-6",
    timezone: "Etc/GMT-6"
  },
  {
    id: "Etc/GMT-7",
    timezone: "Etc/GMT-7"
  },
  {
    id: "Etc/GMT-8",
    timezone: "Etc/GMT-8"
  },
  {
    id: "Etc/GMT-9",
    timezone: "Etc/GMT-9"
  },
  {
    id: "Etc/UTC",
    timezone: "Etc/UTC"
  },
  {
    id: "Europe/Andorra",
    timezone: "Europe/Andorra"
  },
  {
    id: "Europe/Astrakhan",
    timezone: "Europe/Astrakhan"
  },
  {
    id: "Europe/Athens",
    timezone: "Europe/Athens"
  },
  {
    id: "Europe/Belgrade",
    timezone: "Europe/Belgrade"
  },
  {
    id: "Europe/Berlin",
    timezone: "Europe/Berlin"
  },
  {
    id: "Europe/Brussels",
    timezone: "Europe/Brussels"
  },
  {
    id: "Europe/Bucharest",
    timezone: "Europe/Bucharest"
  },
  {
    id: "Europe/Budapest",
    timezone: "Europe/Budapest"
  },
  {
    id: "Europe/Chisinau",
    timezone: "Europe/Chisinau"
  },
  {
    id: "Europe/Dublin",
    timezone: "Europe/Dublin"
  },
  {
    id: "Europe/Gibraltar",
    timezone: "Europe/Gibraltar"
  },
  {
    id: "Europe/Helsinki",
    timezone: "Europe/Helsinki"
  },
  {
    id: "Europe/Istanbul",
    timezone: "Europe/Istanbul"
  },
  {
    id: "Europe/Kaliningrad",
    timezone: "Europe/Kaliningrad"
  },
  {
    id: "Europe/Kirov",
    timezone: "Europe/Kirov"
  },
  {
    id: "Europe/Kyiv",
    timezone: "Europe/Kyiv"
  },
  {
    id: "Europe/Lisbon",
    timezone: "Europe/Lisbon"
  },
  {
    id: "Europe/London",
    timezone: "Europe/London"
  },
  {
    id: "Europe/Madrid",
    timezone: "Europe/Madrid"
  },
  {
    id: "Europe/Malta",
    timezone: "Europe/Malta"
  },
  {
    id: "Europe/Minsk",
    timezone: "Europe/Minsk"
  },
  {
    id: "Europe/Moscow",
    timezone: "Europe/Moscow"
  },
  {
    id: "Europe/Paris",
    timezone: "Europe/Paris"
  },
  {
    id: "Europe/Prague",
    timezone: "Europe/Prague"
  },
  {
    id: "Europe/Riga",
    timezone: "Europe/Riga"
  },
  {
    id: "Europe/Rome",
    timezone: "Europe/Rome"
  },
  {
    id: "Europe/Samara",
    timezone: "Europe/Samara"
  },
  {
    id: "Europe/Saratov",
    timezone: "Europe/Saratov"
  },
  {
    id: "Europe/Simferopol",
    timezone: "Europe/Simferopol"
  },
  {
    id: "Europe/Sofia",
    timezone: "Europe/Sofia"
  },
  {
    id: "Europe/Tallinn",
    timezone: "Europe/Tallinn"
  },
  {
    id: "Europe/Tirane",
    timezone: "Europe/Tirane"
  },
  {
    id: "Europe/Ulyanovsk",
    timezone: "Europe/Ulyanovsk"
  },
  {
    id: "Europe/Vienna",
    timezone: "Europe/Vienna"
  },
  {
    id: "Europe/Vilnius",
    timezone: "Europe/Vilnius"
  },
  {
    id: "Europe/Volgograd",
    timezone: "Europe/Volgograd"
  },
  {
    id: "Europe/Warsaw",
    timezone: "Europe/Warsaw"
  },
  {
    id: "Europe/Zurich",
    timezone: "Europe/Zurich"
  },
  {
    id: "HST",
    timezone: "HST"
  },
  {
    id: "Indian/Chagos",
    timezone: "Indian/Chagos"
  },
  {
    id: "Indian/Maldives",
    timezone: "Indian/Maldives"
  },
  {
    id: "Indian/Mauritius",
    timezone: "Indian/Mauritius"
  },
  {
    id: "MET",
    timezone: "MET"
  },
  {
    id: "MST",
    timezone: "MST"
  },
  {
    id: "MST7MDT",
    timezone: "MST7MDT"
  },
  {
    id: "PST8PDT",
    timezone: "PST8PDT"
  },
  {
    id: "Pacific/Apia",
    timezone: "Pacific/Apia"
  },
  {
    id: "Pacific/Auckland",
    timezone: "Pacific/Auckland"
  },
  {
    id: "Pacific/Bougainville",
    timezone: "Pacific/Bougainville"
  },
  {
    id: "Pacific/Chatham",
    timezone: "Pacific/Chatham"
  },
  {
    id: "Pacific/Easter",
    timezone: "Pacific/Easter"
  },
  {
    id: "Pacific/Efate",
    timezone: "Pacific/Efate"
  },
  {
    id: "Pacific/Fakaofo",
    timezone: "Pacific/Fakaofo"
  },
  {
    id: "Pacific/Fiji",
    timezone: "Pacific/Fiji"
  },
  {
    id: "Pacific/Galapagos",
    timezone: "Pacific/Galapagos"
  },
  {
    id: "Pacific/Gambier",
    timezone: "Pacific/Gambier"
  },
  {
    id: "Pacific/Guadalcanal",
    timezone: "Pacific/Guadalcanal"
  },
  {
    id: "Pacific/Guam",
    timezone: "Pacific/Guam"
  },
  {
    id: "Pacific/Honolulu",
    timezone: "Pacific/Honolulu"
  },
  {
    id: "Pacific/Kanton",
    timezone: "Pacific/Kanton"
  },
  {
    id: "Pacific/Kiritimati",
    timezone: "Pacific/Kiritimati"
  },
  {
    id: "Pacific/Kosrae",
    timezone: "Pacific/Kosrae"
  },
  {
    id: "Pacific/Kwajalein",
    timezone: "Pacific/Kwajalein"
  },
  {
    id: "Pacific/Marquesas",
    timezone: "Pacific/Marquesas"
  },
  {
    id: "Pacific/Nauru",
    timezone: "Pacific/Nauru"
  },
  {
    id: "Pacific/Niue",
    timezone: "Pacific/Niue"
  },
  {
    id: "Pacific/Norfolk",
    timezone: "Pacific/Norfolk"
  },
  {
    id: "Pacific/Noumea",
    timezone: "Pacific/Noumea"
  },
  {
    id: "Pacific/Pago_Pago",
    timezone: "Pacific/Pago_Pago"
  },
  {
    id: "Pacific/Palau",
    timezone: "Pacific/Palau"
  },
  {
    id: "Pacific/Pitcairn",
    timezone: "Pacific/Pitcairn"
  },
  {
    id: "Pacific/Port_Moresby",
    timezone: "Pacific/Port_Moresby"
  },
  {
    id: "Pacific/Rarotonga",
    timezone: "Pacific/Rarotonga"
  },
  {
    id: "Pacific/Tahiti",
    timezone: "Pacific/Tahiti"
  },
  {
    id: "Pacific/Tarawa",
    timezone: "Pacific/Tarawa"
  },
  {
    id: "Pacific/Tongatapu",
    timezone: "Pacific/Tongatapu"
  },
  {
    id: "WET",
    timezone: "WET"
  }
];
